
import { useEffect } from 'react'
import Select from 'react-select'
import { STPEnergyMPCNoDDLAPI, WTPPlantNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const WTPPlantNameDDL = (props) => {
    const { PlantName, setPlantName, WardName, IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_WardID: WardName.ID,
            M_UserID: UserID,
            token: token,
        }
        // if (UnitType.ID) {
        dispatch(WTPPlantNameDDLAPI({ data }))
        // }
    }, [IsPost,WardName.ID])

    const { WTPPlantNameData } = useSelector(state => state.WTPPlantNameDDL)

    useEffect(() => {
        handleWTPPlantNameDDL()
    }, [WTPPlantNameData])

    const handleWTPPlantNameDDL = () => {
        // console.log(DeptDDLDataa)
        if (WTPPlantNameData && WTPPlantNameData.table && WTPPlantNameData.table.length > 0) {
            let list = WTPPlantNameData.table.map((item, index) => ({
                value: item.m_wtP_PlantID,
                label: item.plantName,
            }))

            // setEmployeeDDL({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_EmployeeID : 0,
            //     Label: Flag === 'Update' ? rowData.employeeName : "Select...",
            // })
            setPlantName({ ...PlantName, DDL: list })
        }
        else {
            setPlantName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Plant Name</b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: PlantName.ID, label: PlantName.Label }}
                onChange={(e) => {
                    e ?
                        setPlantName({ ...PlantName, ID: e.value, Label: e.label })
                        :
                        setPlantName({ ...PlantName, ID: 0, Label: "Select..." })

                }}
                options={PlantName.DDL}
            />
        </div>
    )
}